import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 75%;
  padding-bottom: 20rem;

  & > p {
    margin-bottom: 1.7rem;
  }
`;

export const ContactInfo = styled.div`
  margin-bottom: 1.7rem;
  & > a,
  a:link,
  a:visited,
  a:active {
    color: ${({ theme }) => theme.colors.grayDark3};
    font-size: 1.5rem;
    font-weight: 600;
  }
`;
